import { ICaseSearchModel } from '../../interfaces/ICase';
import { useQuery } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';

export const useGetCaseListKey = 'get-case-list';

export const useGetCaseList = (searchModel: ICaseSearchModel, enabled: boolean) => {
    const zoneContext = useZoneContext();
    return useQuery({
        queryKey: [useGetCaseListKey, { searchModel }],
        queryFn: async () => {
            const response = await zoneContext.zoneApiClient.getCases(searchModel);

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (!response.httpResponse.ok) {
                throw new Error(response.errorMessage ?? 'Failed to retrieve the case list');
            }

            return response.payload;
        },
        keepPreviousData: true,
        enabled: enabled && !!searchModel,
        cacheTime: 0,
        staleTime: 0,
    });
};
